// 红利与场馆ID始终使用服务端原字符串，避免JSON浮点编号取错原单。
export function rewardId(value) {
  return typeof value === 'string' && /^[1-9]\d*$/.test(value) && BigInt(value) <= 9223372036854775807n ? value : '';
}
const amount = value => typeof value === 'string' && /^\d+(?:\.\d{1,4})?$/.test(value);
const positive = value => amount(value) && /[1-9]/.test(value);

export function validateRainReward(result, id, kind = 'RAIN') {
  const order = result?.order;
  if (!rewardId(id) || order?.sourceId !== id || order.requiresVenueSelection !== true || !['RAIN', 'SIGN_IN', 'CHALLENGE'].includes(kind) || order.venueClaimKind !== kind ||
      !positive(order.amount) || !amount(order.actualAmount) || typeof result.canSubmit !== 'boolean' ||
      !Array.isArray(result.venues) || !['NOT_STARTED', 'PROCESSING', 'SUCCESS', 'FAILED', 'MANUAL'].includes(result.transferStatus) ||
      typeof result.message !== 'string' || typeof result.transferNo !== 'string' ||
      (result.transferStatus !== 'NOT_STARTED' && !result.transferNo) ||
      (result.canSubmit && (result.transferStatus !== 'NOT_STARTED' || !result.venues.length))) {
    throw new Error('彩金原单回执待核对，请重新查询');
  }
  const seen = new Set();
  for (const venue of result.venues) {
    if (!rewardId(venue.venueId) || seen.has(venue.venueId) || !venue.venueName ||
        !amount(venue.turnoverMultiplier) || !amount(venue.requiredTurnover)) throw new Error('可领取场馆回执待核对');
    seen.add(venue.venueId);
  }
  return result;
}

export const rainRewardClaimed = state => state?.transferStatus === 'SUCCESS' && state.order?.status === 'CLAIMED' && Boolean(state.order.claimedAt);
